
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.swal = require('sweetalert2');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

$(function() {
    let now = new Date();
    let year = now.getFullYear();
    console.log('ready');
    if($(".flashmessage").length > 0) {
        let message = $(".flashmessage").attr("data-message");
        console.log(message);
        swal.fire({
            html: message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok'
        });
    }

    $("#airport").on('change', function() {
        var ap = $("select#airport option:selected").val();
        if(typeof servicetimes !== "undefined") {
            swal.fire({
                text: 'Servicezeiten am Airport '+ap+' von '+servicetimes[ap].start+' bis '+servicetimes[ap].end,
                type:'info'
            })
        }
        if(ap.length == 3) {
            $(".pdflink").removeClass("hidden");
            $(".pdflink").attr('href','/getApPdf/'+ap);
        } else {
            $(".pdflink").addClass("hidden");
        }

    });

    $("#indate").datetimepicker({
        format: 'd.m.Y',
        formatTime: 'H:i',
        formatDate: 'd.m.Y',
        minDate: '-1970/01/02',
        timepicker: false,
        yearStart: year,
        yearEnd: year+1,
    }).attr('readonly', 'readonly');

    $("#outdate").datetimepicker({
        format: 'd.m.Y',
        formatTime: 'H:i',
        formatDate: 'd.m.Y',
        minDate: '-1970/01/02',
        timepicker: false,
        yearStart: year,
        yearEnd: year+1,
    }).attr('readonly', 'readonly');

    $("#bookingsummary").on('submit', function(e) {

        $("#savebooking").attr('disabled', true);

    });

    $(".stornobtn").on('click', function(e) {
        e.preventDefault();
        swal.fire({
            title: 'Wirklich stornieren?',
            text: "",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Nein, abbrechen',
            confirmButtonText: 'Ja, stornieren'
        }).then((result) => {
            if (result.value) {
                console.log(e.target);
                location.href=$(e.target).attr('href');
            }
        })
    })


});


